// SavingsCounter.js
import React, { useState, useEffect, useRef } from 'react';
import CountUp from 'react-countup';
import api from '../utils/api';
import '../StylesComponents/savings-counter.css';

function SavingsCounter() {
  const [stats, setStats] = useState({
    totalSavings: 0,
    averageSavingsPercentage: 0,
    totalDeals: 0,
    activeUsers: 1
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/api/products/stats');
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching savings stats:', error);
      }
    };

    fetchStats();
    // Refresh every 30 seconds for "real-time" feel as products are ingested/removed
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const canvasRef = useRef(null);

  // Canvas Background (Grid)
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let frame;
    const resize = () => {
      if (canvas && canvas.parentElement) {
        canvas.width = window.innerWidth;
        canvas.height = canvas.parentElement.offsetHeight;
      }
    };
    window.addEventListener('resize', resize);
    resize();
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = 'rgba(0, 230, 118, 0.08)';
      ctx.lineWidth = 1.5;
      const step = 80;
      const offset = (Date.now() / 40) % step;
      for(let x=0; x<canvas.width; x+=step) { ctx.beginPath(); ctx.moveTo(x,0); ctx.lineTo(x,canvas.height); ctx.stroke(); }
      for(let y=offset; y<canvas.height; y+=step) { ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(canvas.width,y); ctx.stroke(); }
      frame = requestAnimationFrame(draw);
    };
    draw();
    return () => { window.removeEventListener('resize', resize); cancelAnimationFrame(frame); };
  }, []);

  return (
    <div className="savings-counter">
      <canvas ref={canvasRef} className="section-grid-canvas"></canvas>
      <div className="savings-verification-header">
        <span className="pulse-dot"></span>
        HELPING SHOPPERS SAVE, DAILY
      </div>
      
      <h2 className="savings-counter-header">SMARTER PRICES, DISCOVERED</h2>
      
      <div className="counter-main-display">
        <div className="counter-label">TOTAL SAVINGS DISCOVERED</div>
        <div className="counter-amount-wrapper">
          <span className="dollar-sign">$</span>
          <CountUp
            className="savings-amount"
            start={stats.totalSavings > 1000 ? stats.totalSavings - 1000 : 0}
            end={stats.totalSavings}
            duration={2.5}
            separator=","
            decimals={0}
            preserveValue={true}
          />
        </div>
      </div>

      <div className="savings-stats-grid">
        <div className="stat-box">
          <span className="stat-label">AVERAGE DISCOUNT</span>
          <span className="stat-value">{stats.averageSavingsPercentage}%</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">DEALS AVAILABLE</span>
          <span className="stat-value">{stats.totalDeals}</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">SHOPPERS BROWSING</span>
          <span className="stat-value">
            {stats.activeUsers > 1000 
              ? (stats.activeUsers / 1000).toFixed(1) + 'K' 
              : (stats.activeUsers || 1)}
          </span>
        </div>
      </div>

      <div className="savings-context-footer">
        <p className="context-text">
          We help shoppers discover smarter prices by tracking real-time discounts across our entire
          curated catalog — this figure represents the total savings unlocked by shoppers finding
          active markdowns across Australia.
        </p>
      </div>
    </div>
  );
}

export default SavingsCounter;
